// extracted by mini-css-extract-plugin
export default {"carCardContainer":"CarsCard_carCardContainer__S6Xg-","carCardControl":"CarsCard_carCardControl__ZC+Ud"};